import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ItemProperties } from '../../types.tsx';

export const encodeUserPreferences = (preferences: ItemProperties): ItemProperties => {
	const userPreferences: Record<`up_${string}`, string | boolean | number> = {
		up_isConfigured: true,
	};

	if (preferences) {
		Object.keys(preferences).forEach((key) => {
			userPreferences[`up_${key}`] = preferences[key];
		});
	}

	return userPreferences;
};

export const putUserPreferences = (
	action: string,
	preferences: ItemProperties,
): Promise<void> | null => {
	if (Object.entries(preferences).length === 0) {
		return null;
	}

	const body = JSON.stringify(encodeUserPreferences(preferences));
	return performPutRequest(action, { body });
};
